import Menu from '@/components/Menu/Menu';
import MenuItem from '@/components/Menu/MenuItem';
import { Border, Color, Padding } from '@/GlobalStyles';
import { useSafeAreaInsets } from '@/hooks/useSafeAreaInsets';
import { Image } from 'expo-image';
import { LinearGradient } from 'expo-linear-gradient';
import { Link } from 'expo-router';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

import ProfileMenu from '@/components/Layout/ProfileMenu';
import { I18n } from 'aws-amplify/utils';
import { useTranslation } from 'react-i18next';
import CountryFlag from 'react-native-country-flag';
import DropDownPicker from 'react-native-dropdown-picker';

type HeaderProps = {
  withProfile?: boolean;
};

const Header = (props: HeaderProps) => {
  const { withProfile = true } = props;
  const { i18n, ready } = useTranslation();
  const { top, right, left } = useSafeAreaInsets();

  const changeLanguage = (lng: string) => {
    if (ready) {
      i18n.changeLanguage(lng);
    }
  };

  return (
    <>
      <View
        style={[
          {
            paddingLeft: left,
            paddingTop: top,
            paddingRight: right,
            // backgroundColor: Color.MainBleu,
            height: top + 80,
          },
        ]}
      >
        <LinearGradient
          colors={[Color.VertElectrique, Color.MainBleu]}
          style={styles.backgroundGradient}
          start={[0, 1]}
        />
        <View style={styles.view}>
          <View style={styles.rightBar}>
            <Menu
              isSimplePressable
              modalStyle={{ width: 92 }}
              anchor={
                <View style={styles.profileContainer}>
                  <CountryFlag
                    isoCode={i18n.language == 'en' ? 'gb' : 'fr'}
                    size={20}
                    style={{ marginHorizontal: 8 }}
                  />
                </View>
              }
              anchorContainerStyle={{ alignItems: 'center', justifyContent: 'center' }}
              posX={17}
              position={'left'}
            >
              <MenuItem
                key="menu_language_fr"
                title={<CountryFlag isoCode="fr" size={20} />}
                onPress={async () => {
                  changeLanguage('fr');
                  I18n.setLanguage('fr');
                  DropDownPicker.setLanguage('FR');
                }}
              />
              <MenuItem
                key="menu_language_en"
                title={<CountryFlag isoCode="gb" size={20} />}
                onPress={async () => {
                  changeLanguage('en');
                  I18n.setLanguage('en');
                  DropDownPicker.setLanguage('EN');
                }}
              />
            </Menu>
          </View>
          <View style={styles.rowDirection}>
            <Link href={'/patients'} asChild>
              <Pressable style={styles.logoSigleContainer}>
                <Image
                  style={styles.logoSigle}
                  contentFit="cover"
                  source={require('@assets/logo-horizontal-blanc.png')}
                />
              </Pressable>
            </Link>
          </View>
          <View style={styles.rightBar}>
            {withProfile ? (
              <ProfileMenu />
            ) : (
              <View style={[styles.profileContainer, { borderColor: 'transparent' }]}></View>
            )}
          </View>
        </View>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  rightBar: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  profileContainer: {
    borderRadius: Border.br_sm,
    width: 48,
    padding: Padding.p_7xs,
    justifyContent: 'center',
    height: 48,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: Color.colorGray_100,
    borderStyle: 'solid',
    alignItems: 'center',
    flexDirection: 'row',
    marginHorizontal: Padding.p_lg,
  },
  logoSigle: {
    height: 64,
    width: '100%',
  },
  logoSigleContainer: {
    marginHorizontal: Padding.p_mid,
    width: 150,
    // height: 80,
  },
  backgroundGradient: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    // opacity: 0.03,
    // backgroundColor: Color.MainBleu,
  },
  view: {
    height: 180,
    minHeight: 80,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rowDirection: {
    flexDirection: 'row',
  },
});

export default Header;
